<template>
    <el-dialog
        :title=titele
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form >
         <div class="fuzzy-matching-bottom">
           <el-row class="list">
             <el-table
                :border="true"
                :header-cell-style="{background:'#EDF6FF',color:'#000',}"
                style="width: 100%"
                :data="tableData"
             >
              <el-table-column
                prop="studentName"
                label="姓名"
                >
              </el-table-column>
              <el-table-column
                label="年级|班级"
                >
                <template #default="scope">
                  <span class="shanchuBtn" type="text" size="small"  >{{scope.row.gradeName }}<span v-if="scope.row.gradeNam != null">|</span>{{  scope.row.className }}</span>
                </template>
              </el-table-column>
                <el-table-column
                label='关系'
                >
                <template #default="scope">
                  <div class="shanchuBtn" type="text" size="small"  style="color:red">{{scope.row.relation }}</div>
                  <div class="shanchuBtn" type="text" size="small" >{{  scope.row.time }}</div>

                </template>
              </el-table-column>
              <el-table-column
                prop="imei"
                label="imei"
                >
              </el-table-column>
              <el-table-column
                label="权限"
                >
                  <template #default="scope">
                    <span v-if="scope.row.manager == 1">{{ '管理员' }}</span>
                    <span v-if="scope.row.manager == 0">{{ '家庭成员' }}</span>
                  </template>
              </el-table-column>


              <el-table-column
                label="操作"
                >
                <template #default="scope">
                  <el-button class="shanchuBtn" type="text" size="small" @click="jiebanng(scope.row)" >解绑</el-button>

                </template>
              </el-table-column>

            </el-table>
          </el-row>

    </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { LookVipImei} from '@/assets/api/logapi.js'
import { deviceUnbind} from '@/assets/api/api.js'
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['vipObj'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            form:{
                imei:'',
            },
            cardid:"",
            tableData:[],
            titele:""
          
        }

    },
    created(){
       
    },
    mounted(){
        this.deviceClick()
        this.titele = this.vipObj.name + '的绑定关系'+`    `+'(绑定人数与管理员相关)'
        console.log(this.vipObj.memberId,'vippppppp');
        


    },
    methods:{
      jiebanng(item){
        this.$confirm('确定解除此终端绑定信息吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.jiebangClick(item)
               
            }).catch((err) => {
                console.log(err);        
              
            });
            },
        //解绑接口调用
      jiebangClick(item){
            let userId = JSON.parse(localStorage.getItem('user')).id
            deviceUnbind(item.deviceId,this.vipObj.memberId,userId).then((res)=> {
               this.deviceClick()
               this.$message({
                            type: 'success',
                            message: '解除成功!'
                        });
                }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

                })
        },
      handleClose() {
              this.$emit('closeClick')
        },
      deviceClick(){
          LookVipImei(this.vipObj.memberId).then((res)=> {
          console.log(res.data.data,'查询');
          this.tableData = res.data.data
          // console.log(this.PeopleObj,'查询222');

          // this.
          // this.$message({
          //             type: 'success',
          //             message: '换机成功'
          //         });
          // this.loading = false
          // this.handleClose()
          }).catch((err)=> {
              console.log(err,'查询');
              this.$message({
                      type: 'error',
                      message: err.response.data.msg
                  });
            })
      }
    }
    }




</script>
<style  scoped lang="scss">
    :deep() {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        // margin-left: 180px;


    }
    .el-table--small .cell{
          text-align: center;
        }
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>